import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import './request-new-support-details.style.less';
import { DateTimePeriod } from 'stores/events/events-store';
import './request-new-support-details.style.less';
import { NewSupportPositions, RequestMachinesDto, SupportDetails } from 'stores/requests/requests-store';
import { ItemReference } from 'stores/dataStore';
import { connect } from 'redux-scaffolding-ts';
import { SupportCostsStore } from 'stores/configuration/support-costs/support-costs-store';
import { PatternMachinesViewModel } from 'site/pages/shared/events-and-requests/pattern-machines';
import TailwindPeriodInput from 'widgets/form/period-input-tw';
import TailwindPatternMachines from 'site/pages/shared/events-and-requests/pattern-machines-tw';
import TailwindProfessionEditor from 'widgets/bussiness/profession-editor-tw';
import { shouldHideWorkingManHours, shouldHideWorkingDaysIndicator } from 'site/utils/event-types';

interface TailwidNewRequestSupportDetailsProps extends WithTranslation {
  isForm?: boolean;
  readOnly: boolean;
  onChange: (values) => void;
  supportDetails: SupportDetails;
  startDate: string;
  endDate: string;
  supportCosts?: SupportCostsStore;
  requestLocationId: string;
  eventTypeName?: string;
}

@connect(['supportCosts', SupportCostsStore])
class TailwidNewRequestSupportDetails extends Component<TailwidNewRequestSupportDetailsProps> {
  private get supportCostStore() {
    return this.props.supportCosts;
  }

  private get hideWorkingManHours(): boolean {
    return shouldHideWorkingManHours(this.props.eventTypeName);
  }

  private get hideWorkingDaysIndicator(): boolean {
    return shouldHideWorkingDaysIndicator(this.props.eventTypeName);
  }

  getRawSupportPosition = () => {
    const { startDate, endDate } = this.props;
    const machine: RequestMachinesDto = {
      machineRelatedClusterId: null,
      machineRelatedClusterName: '',
      equipmentTypeId: null,
      equipmentTypeName: '',
      oemId: null,
      oemName: '',
      machineModelId: null,
      machineModelName: '',
      plcTypeRequestMachines: [],
      machineUnitRequestMachines: []
    };
    const tempItems = [];
    tempItems.push(machine);
    return {
      endDate: endDate,
      startDate: startDate,
      patternId: null,
      patternName: null,
      machineModels: tempItems,
      supportPositionRoleId: null,
      requestedHC: 0,
      requestedManDays: 0,
      requestedWorkingManHours: 0,
      theoreticalCost: 0
    };
  };

  private handleOnPatternMachinesChange = ({ pattern, machines }: PatternMachinesViewModel, index: number) => {
    const newSupportPositions = this.props.supportDetails.newSupportPositions.map((supportPos, idx) => {
      if (idx === index) {
        supportPos.patternId = pattern?.id ?? null;
        supportPos.patternName = pattern?.title ?? null;
        supportPos.machineModels = (machines || []).map(
          ({ cluster, equipmentType, machineModel, machineUnits, oem, plcTypes, hasAvailablePlcTypes }) => ({
            machineRelatedClusterId: cluster?.id,
            machineRelatedClusterName: cluster?.title,
            equipmentTypeId: equipmentType?.id,
            equipmentTypeName: equipmentType?.title,
            oemId: oem?.id,
            oemName: oem?.title,
            machineModelId: machineModel?.id,
            machineModelName: machineModel?.title,
            plcTypeRequestMachines: plcTypes,
            machineUnitRequestMachines: machineUnits,
            hasAvailablePlcTypes: hasAvailablePlcTypes
          })
        );
      }

      return supportPos;
    });
    this.props.onChange({ newSupportPositions });
  };

  handleNewSupportPosition = () => {
    const supportDetails = this.props.supportDetails;
    let newSupportPosition;
    if ((supportDetails.newSupportPositions || []).length <= 0) {
      newSupportPosition = { ...this.getRawSupportPosition() };
    } else {
      newSupportPosition = {
        ...this.getRawSupportPosition()
      };
    }
    this.props.onChange({ newSupportPositions: [...supportDetails.newSupportPositions, newSupportPosition] });
  };

  removeSupportPosition = (index: number) => {
    const newSupportPositions = this.props.supportDetails.newSupportPositions.filter((_, i) => i !== index);
    const totalRequestedManDays = newSupportPositions.reduce((prevVal, acc) => prevVal + Number(acc['requestedManDays']), 0);
    const totalRequestedManMonths = totalRequestedManDays / 30;
    const totalRequestedWorkingManHours = newSupportPositions.reduce(
      (prevVal, acc) => prevVal + Number(acc['requestedWorkingManHours']),
      0
    );
    const totalTheoreticalCost = newSupportPositions.reduce((prevVal, acc) => prevVal + Number(acc['theoreticalCost']), 0);

    this.props.onChange({
      newSupportPositions,
      totalRequestedWorkingManHours: totalRequestedWorkingManHours,
      totalRequestedManDays: totalRequestedManDays,
      totalRequestedManMonths: totalRequestedManMonths,
      totalTheoreticalCost: totalTheoreticalCost
    });
  };

  roleChange = (value: ItemReference, index: number) => {
    const newSupportPositions = this.props.supportDetails.newSupportPositions.map((supportPos, idx) => {
      if (idx === index) {
        supportPos = { ...supportPos, supportPositionRoleId: value ? value.id : null, supportPositionRoleName: value ? value.title : '' };
      }
      return supportPos;
    });
    this.props.onChange({ newSupportPositions });
  };

  capitalize = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

  inputChangeHandler = (property: string, idx: number, value: string) => {
    const newSupportPositions = this.props.supportDetails.newSupportPositions.map((supportPos, i) => {
      if (i === idx) {
        supportPos = { ...supportPos, [property]: property !== 'theoreticalCost' ? value : Number(value) };
      }
      return supportPos;
    });

    if (property === 'requestedHC' && value !== '') {
      this.calculateTheoreticalCost(idx, Number(value));
    } else {
      this.props.onChange({ newSupportPositions });
    }
  };

  calculateTheoreticalCost = async (idx: number, value: number, from?: string, to?: string) => {
    this.props.onChange({ readOnly: true });
    const newSupportPositions = await Promise.all(
      this.props.supportDetails.newSupportPositions.map(
        async (supportPos, i): Promise<NewSupportPositions> => {
          if (i === idx) {
            const data = await this.supportCostStore.getSupportPositionCost(
              this.props.requestLocationId,
              from || supportPos.startDate,
              to || supportPos.endDate,
              value.toString()
            );
            supportPos = {
              ...supportPos,
              requestedManDays: data?.requestedManDays,
              requestedWorkingManHours: data?.requestedWorkingManHours,
              theoreticalCost: data?.theoreticalCost,
              requestedHC: value,
              startDate: from || supportPos.startDate,
              endDate: to || supportPos.endDate
            };
          }
          return supportPos;
        }
      )
    );
    const totalRequestedManDays = newSupportPositions.reduce((prevVal, acc) => prevVal + Number(acc['requestedManDays']), 0);
    const totalRequestedManMonths = totalRequestedManDays / 30;
    const totalRequestedWorkingManHours = newSupportPositions.reduce(
      (prevVal, acc) => prevVal + Number(acc['requestedWorkingManHours']),
      0
    );
    const totalTheoreticalCost = newSupportPositions.reduce((prevVal, acc) => prevVal + Number(acc['theoreticalCost']), 0);

    this.props.onChange({
      readOnly: false,
      newSupportPositions,
      totalRequestedWorkingManHours: totalRequestedWorkingManHours,
      totalRequestedManDays: totalRequestedManDays,
      totalRequestedManMonths: totalRequestedManMonths,
      totalTheoreticalCost: totalTheoreticalCost
    });
  };

  datesChangeHandler = ({ from, to }: DateTimePeriod, idx: number) => {
    const { startDate, endDate, requestedHC } = this.props.supportDetails.newSupportPositions[idx];
    let newSupportPositions;
    if (startDate && from !== startDate) {
      newSupportPositions = this.props.supportDetails.newSupportPositions.map((supportPos, i) => {
        if (i === idx) supportPos = { ...supportPos, startDate: from };
        return supportPos;
      });
    } else if (endDate && to !== endDate) {
      newSupportPositions = this.props.supportDetails.newSupportPositions.map((supportPos, i) => {
        if (i === idx) supportPos = { ...supportPos, endDate: to };
        return supportPos;
      });
    } else return;
    this.props.onChange({ newSupportPositions });
    if (from && to && requestedHC > 0) {
      this.calculateTheoreticalCost(idx, requestedHC, from, to);
    }
  };

  render() {
    const { t, readOnly } = this.props;
    const { supportDetails } = this.props;
    const { isForm } = this.props;
    const {
      totalRequestedWorkingManHours,
      totalRequestedManDays,
      totalRequestedManMonths,
      totalTheoreticalCost,
      newSupportPositions
    } = supportDetails;
    // const divHiddenStyle = {
    //   display: 'none'
    // };

    return (
      <>
        {/* <div className="flex items-center gap-4">
          <label className="text-sm text-gray-700">{t('Request pre-approved during ASP')}</label>
          <div className="flex items-center">
            <input
              id="default-checkbox"
              type="checkbox"
              value=""
              checked={requestPreApprovedDuringASP}
              className="w-4 h-4 text-black-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              onChange={checked => this.props.onChange({ requestPreApprovedDuringASP: checked })}
            />
          </div>
        </div> */}

        <button
          disabled={readOnly}
          onClick={this.handleNewSupportPosition}
          className={`w-full ${readOnly ? 'bg-gray-600' : 'bg-primary-600'} text-white py-2 rounded mt-2`}
        >
          {t('Add Support Position')}
        </button>

        {!this.hideWorkingManHours && (
          <div>
            <label className="text-sm text-gray-700">{t('Total Requested Working Man Hours')}</label>
            <input
              className="w-full border border-gray-300 p-2 rounded bg-gray-100"
              onChange={null}
              disabled
              value={totalRequestedWorkingManHours}
            />
          </div>
        )}
        <div>
          <label className="text-sm text-gray-700">{t('Total Requested Man Days')}</label>
          <input className="w-full border border-gray-300 p-2 rounded bg-gray-100" onChange={null} disabled value={totalRequestedManDays} />
        </div>
        <div>
          <label className="text-sm text-gray-700">{t('Total Requested Man Months')}</label>
          <input
            className="w-full border border-gray-300 p-2 rounded bg-gray-100"
            onChange={null}
            disabled
            value={Number(totalRequestedManMonths).toFixed(2)}
            type="number"
            step="0.01"
          />
        </div>

        <div>
          <label className="text-sm text-gray-700">{t('Total Theoretical Cost')}</label>
          <div className="flex items-center gap-2">
            <input
              className="w-full border border-gray-300 p-2 rounded bg-gray-100"
              onChange={null}
              disabled
              value={Number(totalTheoreticalCost).toFixed(2)}
              type="number"
              step="0.01"
            />
            <span className="whitespace-nowrap">$</span>
          </div>
        </div>

        {(newSupportPositions || []).length > 0 &&
          newSupportPositions.map(
            (
              {
                requestedHC,
                startDate,
                endDate,
                requestedManDays,
                requestedWorkingManHours,
                theoreticalCost,
                supportPositionRoleId,
                patternId,
                patternName,
                machineModels
              },
              i
            ) => {
              const myPattern = patternId ? ({ id: patternId, title: patternName ?? '' } as ItemReference) : null;
              const myMachines = (machineModels || []).map(m => ({
                cluster: m.machineRelatedClusterId ? { id: m.machineRelatedClusterId, title: m.machineRelatedClusterName } : null,
                equipmentType: m.equipmentTypeId ? { id: m.equipmentTypeId, title: m.equipmentTypeName } : null,
                oem: m.oemId ? { id: m.oemId, title: m.oemName } : null,
                machineModel: m.machineModelId ? { id: m.machineModelId, title: m.machineModelName } : null,
                machineUnits: m.machineUnitRequestMachines,
                plcTypes: m.plcTypeRequestMachines,
                hasAvailablePlcTypes: m.hasAvailablePlcTypes
              }));
              const patternMachines: PatternMachinesViewModel = { pattern: myPattern, machines: myMachines };
              return (
                <div key={i} className="bg-gray-50 p-4 rounded-lg mb-4">
                  <div>
                    <label className="text-sm text-gray-700">{t('Dates')}</label>
                    <TailwindPeriodInput
                      id={'request-suppport-details-' + i}
                      readOnly={readOnly}
                      onChange={period => this.datesChangeHandler(period, i)}
                      icon={false}
                      value={{ from: startDate, to: endDate }}
                    />
                  </div>

                  <div>
                    <div className="form__event-details-tab__mr__pattern form__event-details-tab__element mr-table-component__common-styles">
                      <TailwindPatternMachines
                        readOnly={readOnly}
                        value={patternMachines}
                        onChange={p => this.handleOnPatternMachinesChange(p, i)}
                        loadPatternsOnOpen={true}
                        profession={supportPositionRoleId ? { id: supportPositionRoleId, title: '' } : null}
                        warningMessageEnabled={isForm != null ? !isForm : false}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="text-sm text-gray-700">{t('Role')}</label>
                    <TailwindProfessionEditor
                      readOnly={readOnly}
                      placeholder={t('Role')}
                      value={supportPositionRoleId ? { id: supportPositionRoleId, title: '' } : null}
                      onChange={role => this.roleChange(role, i)}
                    />
                  </div>
                  <div>
                    <label className="text-sm text-gray-700">{t('Requested HC')}</label>
                    <input
                      className="w-full border border-gray-300 p-2 rounded"
                      disabled={readOnly}
                      type="number"
                      value={requestedHC}
                      onChange={e => this.inputChangeHandler('requestedHC', i, e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="text-sm text-gray-700">{t('Requested Man Days')}</label>
                    {this.hideWorkingDaysIndicator ? (
                      <input
                        disabled
                        type="number"
                        className="w-full border border-gray-300 p-2 rounded bg-gray-100"
                        value={requestedManDays}
                        onChange={e => this.inputChangeHandler('requestedManDays', i, e.target.value)}
                      />
                    ) : (
                      <div className="flex items-center gap-2">
                        <input
                          disabled
                          type="number"
                          className="flex-1 border border-gray-300 p-2 rounded bg-gray-100"
                          value={requestedManDays}
                          onChange={e => this.inputChangeHandler('requestedManDays', i, e.target.value)}
                        />
                        <span className="whitespace-nowrap">w/d</span>
                      </div>
                    )}
                  </div>
                  {!this.hideWorkingManHours && (
                    <div>
                      <label className="text-sm text-gray-700">{t('Requested Working Man hours')}</label>
                      <input
                        disabled
                        className="w-full border border-gray-300 p-2 rounded bg-gray-100"
                        type="number"
                        onChange={e => this.inputChangeHandler('requestedWorkingManHours', i, e.target.value)}
                        value={requestedWorkingManHours}
                      />
                    </div>
                  )}

                  <div>
                    <label className="text-sm text-gray-700">{t('Theoretical Cost')}</label>
                    <div className="flex items-center gap-2">
                      <input
                        disabled
                        className="w-full border border-gray-300 p-2 rounded bg-gray-100"
                        type="number"
                        step="0.01"
                        min="0"
                        onChange={value => this.inputChangeHandler('theoreticalCost', i, `${value}`)}
                        value={Number(theoreticalCost).toFixed(2)}
                      />
                      <span className="whitespace-nowrap">$</span>
                    </div>
                  </div>

                  {!readOnly && (
                    <>
                      <div className="flex justify-end mt-6" onClick={() => this.removeSupportPosition(i)}>
                        <svg
                          className="w-6 h-6 text-gray-800 dark:text-white"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                          />
                        </svg>
                      </div>
                    </>
                  )}
                </div>
              );
            }
          )}
      </>
    );
  }
}

export default withTranslation()(TailwidNewRequestSupportDetails);
